import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-user-onboarding-success-dialog',
  templateUrl: './user-onboarding-error-dialog.component.html',
})
export class UserOnboardingErrorDialogComponent {
  constructor(
    public readonly drawerRef: MatDialogRef<UserOnboardingErrorDialogComponent>,
  ) {}
}
